module.exports = __webpack_public_path__ + "static/CNX Trans-a3168a424194014f8cb9a949411cf81e.png";